import {
  LOGIN_ROLE_SUCCESS,
  LOGIN_ROLE_FAILED,
  RESET_LOGIN_ROLE,
  LOADING_LOGIN_ROLE,
  NETWORK_ERROR_LOGIN_ROLE,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_LOGIN_ROLE:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case LOGIN_ROLE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case LOGIN_ROLE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_LOGIN_ROLE:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_LOGIN_ROLE:
      return (state = initialState);
    default:
      return state;
  }
};
